module.exports = __webpack_public_path__ + "img/23_newModelWorker_zss.43f2be31.png";